import { render } from "./LanguageSwitcher.vue?vue&type=template&id=120682a9"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
script.render = render

export default script